import { render, staticRenderFns } from "./SumupList.vue?vue&type=template&id=ef773a7c&scoped=true&"
import script from "./SumupList.vue?vue&type=script&lang=ts&"
export * from "./SumupList.vue?vue&type=script&lang=ts&"
import style0 from "./SumupList.vue?vue&type=style&index=0&id=ef773a7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef773a7c",
  null
  
)

export default component.exports